/* eslint-disable */
import lozad from 'lozad';
import '../util/parallax';

export default {
  init() {
    // JavaScript to be fired on all pages

    //Lazy load images bc there's a bunch
    const observer = lozad('.lozad', {
      rootMargin: '500px 0px',
      threshold: 0.1,
      load: function(el) {
        el.src = el.dataset.src;
        el.classList.add('loaded');
      },
    });
    observer.observe();

    function addHeadersToOffCanvasMenu() {
      $('.off-canvas-menu li')
        .first()
        .before('<div class="title">Solutions</div>');
    }

    addHeadersToOffCanvasMenu();

    //Hamburger toggle
    $('#nav-icon1,#nav-icon2,#nav-icon3,#nav-icon4').click(function() {
      $(this).toggleClass('open');
      $('.off-canvas-menu').toggleClass('active');
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });

    ///////////////////////////////////////////////////////////////////////
    //Utility //////////////////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////

    //kill empty p tags added by wp
    $('p:empty').remove();

    let width = $(window).width();
    $(window).resize(function() {
      width = $(window).width();
    });

    if (width < 550) {
      $('.wistia_responsive_padding').removeClass('fade-in');
    }

    //////////////////////////////////////////////////////////////////////////
    // SCROLL LISTENERS //////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////////////////////

    //Scroll Listener for header, video fade-in, in-field benefits component
    const myElements = document.querySelectorAll('.fade-in, h2.header');
    let options = {
      root: null,
      rootMargin: '0px 0px -60px 0px',
      threshold: [0, 0.1],
    };

    let scrollObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        //if the element is 100% in view
        if (entry.intersectionRatio > 0) {
          entry.target.classList.add('show');
          scrollObserver.unobserve(entry.target);
        }
      });
    }, options);

    myElements.forEach(image => {
      scrollObserver.observe(image);
    });

    ////////////////////////Header Scroll logic
    // Hide Header on on scroll down
    var didScroll;
    var lastScrollTop = 0;
    var delta = 10;
    // var navbarHeight = $('header.main').outerHeight();
    let windowScrollTop = $(window).scrollTop();

    // eslint-disable-next-line no-unused-vars
    $(window).scroll(function(event) {
      didScroll = true;

      windowScrollTop = $(window).scrollTop();

      if (width >= 1023) {
        //changed to 360px from navBar height for product page subnav
        if (windowScrollTop >= 360) {
          $('.product-subnav').addClass('animated');
        }

        //don't animate subnav at top of the page otherwise it looks weird with header animation
        if (windowScrollTop >= 347) {
          $('.product-subnav').addClass('smart-nav');
          $('.subnav-fill').addClass('active');
        } else {
          $('.product-subnav').removeClass('smart-nav');
          $('.subnav-fill').removeClass('active');
          $('.product-subnav').removeClass('animated');
        }
      }
    });

    setInterval(function() {
      if (didScroll) {
        hasScrolled();
        didScroll = false;
      }
    }, 500);

    function hasScrolled() {
      var st = $(document).scrollTop();

      // Make sure they scroll more than delta
      if (Math.abs(lastScrollTop - st) <= delta) return;

      // If they scrolled down and are past the navbar, add class .nav-up.
      // This is necessary so you never see what is "behind" the navbar.
      // if (st > lastScrollTop && st > navbarHeight) {
      if (st > lastScrollTop && st > 344) {
        // Scroll Down
        $('header.main')
          .removeClass('nav-down')
          .addClass('nav-up');
        $('.subnav')
          .removeClass('nav-down')
          .addClass('nav-up');
      } else {
        // Scroll Up
        if (st + $(window).height() < $(document).height()) {
          $('header.main')
            .removeClass('nav-up')
            .addClass('nav-down');
          $('.subnav')
            .removeClass('nav-up')
            .addClass('nav-down');
        }
      }
      lastScrollTop = st;
    }

    if (width >= 1024) {
      $('.off-canvas-menu').removeClass('active');
    }

    ///////////////////////////////////////////////////////////////////////////
    /////Make C2 Superscript ////////////////////////////////////////////////
    ///////////////////////////////////////////////////////////////////////////

    $('body :not(script)')
      .contents()
      .filter(function() {
        return this.nodeType === 3;
      })
      .replaceWith(function() {
        return this.nodeValue.replace('C2', 'C<sup>2</sup>');
      });

    //repeat process
    $('body :not(script)')
      .contents()
      .filter(function() {
        return this.nodeType === 3;
      })
      .replaceWith(function() {
        return this.nodeValue.replace('C2', 'C<sup>2</sup>');
      });


  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js